/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import { ROUTES, TABLE_NAMES } from "@/shared";

import { useStyles } from "../../shared/styles/sharedStyles";
import DetailsSection from "../DetailsSection/DetailsSection";
import PageHeader from "../PageHeader/PageHeader";

interface ILayoutWithDetailsProps {
  route: ROUTES;
  tableName: TABLE_NAMES;
  children: ReactNode;
  infoIconTooltip?: string;
}

const LayoutWithDetails = ({
  route,
  tableName,
  children,
  infoIconTooltip
}: ILayoutWithDetailsProps) => {
  const { pageLayout } = useStyles();

  return (
    <div data-testid="layout-with-details" css={css(pageLayout)}>
      <PageHeader
        route={route}
        tableName={tableName}
        infoIconTooltip={infoIconTooltip}
      >
        {children}
      </PageHeader>
      <DetailsSection route={route} />
    </div>
  );
};

export default LayoutWithDetails;
